import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import MoneyFormat from '../UI/Money/MoneyFormat';
import { FaInfoCircle, FaRegCalendar } from 'react-icons/fa';
import GridCardWrapper, {
  ImageWrapper,
  FavoriteIcon,
  ContentWrapper,
  LocationArea,
  TitleArea,
  PriceArea,
  MetaWrapper,
  ButtonGroup,
  DetailReserverArea,
  PriceReserverArea,
} from './GridCard.style';
import { SharedDataContext } from 'context/SharedDataProvider';

const GridCard = ({
  className,
  favorite,
  location,
  title,
  price,
  editBtn,
  viewDetailsBtn,
  children,
  info,
  currency,
  displayReview,
  isClient,
  detailsBtn,
  priceSansPromo,
  descriptionOffre,
  isRemise,
  loadTarif,
  id
}) => {
  let classes = viewDetailsBtn || editBtn ? `has_btn ${className}` : className;
  const { isFiltreDayUseChecked } = useContext(SharedDataContext);

  return (
    <GridCardWrapper className={`grid_card ${classes}`.trim()}>
      <ImageWrapper className="media_wrapper">{children}</ImageWrapper>
      <ContentWrapper className="content_wrapper">
        {location && <LocationArea title={location}>{location}</LocationArea>}
        {title && <TitleArea title={title?.props?.content??""}>{title}</TitleArea>}
        <MetaWrapper className="meta_wrapper">
          {/* <p>{</p> */}
          <PriceReserverArea>
            {
              !isRemise ? <PriceArea className="price">
                  <MoneyFormat value={`${priceSansPromo??price}`} suffix={` ${currency}`}/>
              </PriceArea>
              :
              <>
                <PriceArea className="price">
                  <MoneyFormat value={`${price}`} suffix={` ${currency}`} /></PriceArea>
                <PriceArea className="price real-price">
                  <MoneyFormat value={`${priceSansPromo}`} suffix={` ${currency}`} addSuffix={!priceSansPromo}/>
                </PriceArea>
              </>
            }
            { !isFiltreDayUseChecked && priceSansPromo &&
              <FaInfoCircle style={{"color" : "red", "margin" : "3px 3px 0 3px"}} title={descriptionOffre}>
              </FaInfoCircle>
            }

            {/* {price && 
                <PriceArea className="price">
                <MoneyFormat value={`${price}`} suffix={` ${currency}`} /></PriceArea>
            } */}
            {/* {!isFiltreDayUseChecked && priceSansPromo && 
                <PriceArea className="price real-price">
                <MoneyFormat value={`${priceSansPromo}`} suffix={` ${currency}`} addSuffix={!priceSansPromo}/>
                <FaInfoCircle style={{"color" : "red", "margin" : "3px 3px 0 3px"}} title={descriptionOffre}>
                </FaInfoCircle></PriceArea>
            } */}
            {
              (!isFiltreDayUseChecked && detailsBtn) && <FaRegCalendar onClick={()=>loadTarif(id,title)} title='Cliquez ici pour visualiser le calendrier des tarifs !' style={{'margin-left':'10px', 'cursor':'pointer'}} className="calendar" />
            }
            
          </PriceReserverArea>
          {info}
          <DetailReserverArea>
            {detailsBtn || editBtn  &&
              <ButtonGroup detailsBtn>
                {detailsBtn}
                {editBtn}
              </ButtonGroup> 
            }
            {viewDetailsBtn || editBtn  (
              <ButtonGroup className="button_group">
                {viewDetailsBtn}
                {editBtn}
              </ButtonGroup>
            ) }
         </DetailReserverArea>
        </MetaWrapper>
        
        <MetaWrapper>
          {displayReview}
        </MetaWrapper>
      </ContentWrapper>

      { isClient && favorite && <FavoriteIcon>{favorite}</FavoriteIcon>}
    </GridCardWrapper>
  );
};

GridCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  price: PropTypes.string,
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  editBtn: PropTypes.element,
  viewDetailsBtn: PropTypes.element,
  loadTarif:PropTypes.func
};

export default GridCard;
